/* eslint-disable @reatom/unit-naming-rule */
import { reatomResource } from '@root/shared/lib'

import { fetchWalletTransfersRequestAction } from './wallet-transfers-requests'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'

/** Loads when the tab that shows it is mounted, and not before. */
export const reatomWalletTransfers = ({
  walletAddress,
  network,
}: {
  walletAddress: Address
  network: Network.Network
}) =>
  reatomResource(
    async (ctx) =>
      ctx.schedule(() =>
        fetchWalletTransfersRequestAction(ctx, { network, walletAddress }),
      ),
    { name: 'reatomWalletTransfers', loadOnConnect: true },
  )
